/** График подразделения на неделю — ровно то, что отдаёт `GET /api/schedule/week`. */
import { apiFetch, query } from "@/lib/api";

export type Location = { id: number; name: string; short: string; tz: number };

export type Cell = { minutes: number; intervals: { from: string; to: string }[]; extra: boolean };

/** Факт дня: минуты в оплачиваемых статусах и акцепт (0 — ещё не подтверждён). */
export type Fact = { minutes: number; accept: number };

export type Person = {
  user_id: number;
  name: string;
  minutes: number;
  shifts: number;
  days: Record<string, Cell>;
  fact: Record<string, Fact>;
  /** Итоги план-факта — по прошедшим дням, без сегодняшнего. */
  plan_to_date: number;
  fact_minutes: number;
  accept_minutes: number;
  absent: number;
  unplanned: number;
};

export type ScheduleWeek = {
  location: Location;
  locations: Location[];
  week: { start: string; end: string; iso: string };
  today: string;
  /** `fact`/`accept`/`fact_staff` — `null` у будущих дней. */
  days: { date: string; minutes: number; staff: number; fact: number | null; accept: number | null; fact_staff: number | null }[];
  total: { minutes: number; staff: number; shifts: number; plan_to_date: number; fact: number; accept: number };
  people: Person[];
  filled: boolean;
  last_planned: string | null;
};

export function loadSchedule(location: number, day: string): Promise<ScheduleWeek> {
  return apiFetch<ScheduleWeek>(`/api/schedule/week${query({ location: String(location), date: day })}`);
}

/** Период вкладки «По неделям»: неделя или несколько недель подряд, свежие первыми. */
export type WeeksPeriod = {
  key: string;
  start: string;
  end: string;
  /** Недель в периоде; меньше шага — период неполный (самый старый в году). */
  weeks: number;
  week_from: number;
  week_to: number;
  minutes: number;
  staff: number;
};

export type WeeksPerson = {
  user_id: number;
  name: string;
  active: boolean;
  minutes: number;
  /** Минуты акцепта по ключу периода; периода без акцепта в объекте нет. */
  periods: Record<string, number>;
};

/** Ровно то, что отдаёт `GET /api/schedule/weeks`. */
export type ScheduleWeeks = {
  location: Location;
  locations: Location[];
  year: number;
  years: number[];
  group: number;
  today: string;
  periods: WeeksPeriod[];
  total: { minutes: number; staff: number };
  people: WeeksPerson[];
};

export function loadScheduleWeeks(location: number, year: number, group: number): Promise<ScheduleWeeks> {
  return apiFetch<ScheduleWeeks>(
    `/api/schedule/weeks${query({ location: String(location), year: String(year), group: String(group) })}`,
  );
}

/** Минуты → часы для графика: 540 → «9 ч», 570 → «9,5 ч». */
export function hours(minutes: number): string {
  return `${(Math.round((minutes / 60) * 10) / 10).toLocaleString("ru-RU")} ч`;
}
